import {
  dialogContentClasses,
  styled,
  DialogActions as BaseDialogAction,
  DialogContent as BaseDialogContent,
  DialogTitle as BaseDialogTitle,
  Dialog as BaseDialog,
  dialogClasses,
} from '@mui/material'

export const Root = styled(BaseDialog)(({ theme }) => ({
  [`& .${dialogClasses.paper}`]: {
    margin: theme.spacing(2),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    maxWidth: 600,
    width: '100%',
  },

  [`& .${dialogContentClasses.root}`]: {
    position: 'relative',
  },
}))

export const DialogTitle = styled(BaseDialogTitle)(({ theme }) => ({
  padding: theme.spacing(3, 3, 2, 3),
  color: theme.palette.grey[800],
}))

export const DialogContent = styled(BaseDialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  color: theme.palette.grey[700],
}))

export const DialogActions = styled(BaseDialogAction)(({ theme }) => ({
  padding: theme.spacing(3, 2, 3, 3),
}))
